import React, { useEffect } from 'react';
import Navbar from '../../Navbar';
import GroupChat from '../GroupChat';
import ScoreDetails from './ScoreDetails';

const ChatPage = () => {
    return (
        <React.Fragment>
            <div className="row ">
                <div className="col-lg-9 col-sm-9 col-md-9 ques-page p-0">
                    <Navbar />
                    <div className="container ques-cont">
                        <ScoreDetails />
                    </div>
                </div>
                <div className="col-lg-3 col-sm-3 col-md-3 chat-area p-0">
                    <GroupChat />
                </div>
            </div>
        </React.Fragment>
    );
};

export default ChatPage;